import { action, flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { getStorage, removeStorage, saveLocalStorage } from '@/utils/browsers';
import { AuthApi } from '@/apis';
import { ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import { t } from 'i18next';
import { Profile } from '@/types/auth';
import { ResponseData } from '@/types/http';
import { GetOtpRequest, LoginPostResponse, LoginRequest, SignUpRequest, VerifyOtpRequest } from '@/types/http-payload/auth';

export default class AuthStore extends BaseStore {
    profile?: any = getStorage('profile', true);
    token: string = getStorage('token');
    api: AuthApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            profile: observable,
            token: observable,
            login: flow.bound,
            logout: action.bound,
            getProfile: flow.bound,
            clearAuthentication: action.bound,
            signUp: flow.bound,
            sentOTP: flow.bound,
            verifyOTP: flow.bound,
            generateResistration: flow.bound,
            generateAuthentication: flow.bound,
            getXInfo: flow.bound,
            getMyInfo: flow.bound,
            updateMyInfo: flow.bound
        });
        this.api = new AuthApi();
    }

    *login(payload: LoginRequest) {
        try {
            const res: ResponseData<LoginPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.login, payload);
            if (res?.ok) {
                this.token = res.data.token;
                // const { userInfo } = res.data;
                // if (userInfo) {
                //     this.profile = { ...this.profile, userInfo: userInfo };
                // }
                saveLocalStorage('token', res.data.token);
                // saveLocalStorage('profile', JSON.stringify(this.profile));
                toastify('success', t('messages.sign_in_success'));
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *getProfile() {
        try {
            const res: ResponseData<Profile> = yield this.rootStore.apiStore.call(this.api, this.api.getProfile);
            if (res?.ok) {
                this.profile = res.data;
            }
        } catch (error) {
        }
    }

    updateProfile(profile: Profile) {
        this.profile = profile;
    }

    logout() {
        try {
            this.rootStore.apiStore.call(this.api, this.api.logout);
            this.clearAuthentication();
        } catch (error) {
        }
    }

    clearAuthentication() {
        removeStorage(['token', 'profile']);
        window.location.href = ROUTES.login.href;
    }

    *signUp(payload: SignUpRequest) {
        try {
            const res: ResponseData<LoginPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.signUp, payload);
            if (res?.ok) {
                if (res.data.token) {
                    this.token = res.data.token;
                    saveLocalStorage('token', res.data.token);
                }
                toastify('success', t('messages.signUpSuccess'));
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *sentOTP(payload: GetOtpRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getOtp, payload);
            return res.ok || false;
        } catch (error) {
            return false;
        }
    }

    *verifyOTP(payload: VerifyOtpRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.verifyOtp, payload);
            return res.ok || false;
        } catch (error) {
            return false;
        }
    }

    *generateResistration(payload: GetOtpRequest) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.generateResistration, payload);
            if (res && res.ok) {
                const { data } = res;
                return data || null;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *generateAuthentication(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.generateAuthentication, payload);
            if (res && res.ok) {
                const { data } = res;
                return data || null;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getXInfo(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getInfoX, payload);
            if (res && res.ok) {
                const { data } = res;
                return data || null;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getMyInfo() {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getMyInfo);
            if (res && res.ok) {
                const { data } = res;
                saveLocalStorage('profile', JSON.stringify(data));
                this.profile = data;
                return data || null;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *updateMyInfo(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.updateMyInfo, payload);
            if (res && res.ok) {
                this.getMyInfo();
                toastify('success', t('messages.updateSuccess'));
                return res.ok;
            }
            return null;
        } catch (error) {
            return null;
        }
    }
}
